$('.logo-slider').each(function () {
	const $swiperEl = $(this).find('.swiper')[0];

	const swiper = new Swiper($swiperEl, {
		allowTouchMove: false,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		loop: true,
		slidesPerView: 5,
		spaceBetween: 48,
		speed: 2500,
		breakpoints: {
			0: {
				slidesPerView: 4,
			},
			640: {
				slidesPerView: 5,
			},
		},
	});
});
